import get from 'lodash/get'

import { getQueryValue } from 'selectors/pageStateSelectors'
import { getEntity } from 'selectors/entitySelectors'
import { STATE_KEY as SK } from 'reducers/leadReducers'

export const getSelectedDateRange = (state, def) =>
    getQueryValue(state, 'leads.dateRange', def || 'weekToDate'),
  getGGLeadIds = state =>
    get(state, `${SK}.leadIds`, []).sort(
      (a, b) => getLeadLastSeen(state, b) - getLeadLastSeen(state, a),
    ),
  getLeadSummaries = state =>
    get(state, `${SK}.leadIds`, [])
      .sort((a, b) => getLeadLastSeen(state, b) - getLeadLastSeen(state, a))
      .map(id => {
        return { id, ...getEntity(state, id, {}).summary }
      }),
  getLeadLastSeen = (state, id) => {
    let lead = getEntity(state, id, {})

    return get(lead, 'lastSeen', 0)
  }
